/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketBoosterLeaderboardRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetMarketBoosterLeaderboardArgs, useGetMarketBoosterLeaderboardSpec, useGetMarketBoosterLeaderboardRealtime, useGetMarketBoosterLeaderboardPagination } from '../specs/markets.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetMarketBoosterLeaderboardRow } from '../openapi-types.gen.js';
export type { useGetMarketBoosterLeaderboardArgs } from '../specs/markets.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetMarketBoosterLeaderboardPaginationContract = useGetMarketBoosterLeaderboardPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetMarketBoosterLeaderboardInfinite` — both
 * read/write the same `PagedData<GetMarketBoosterLeaderboardRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): pubkey, sortBy, sortOrder, limit, cursor.
 */
const _useGetMarketBoosterLeaderboard = createListHook({
  spec: useGetMarketBoosterLeaderboardSpec,
  realtime: useGetMarketBoosterLeaderboardRealtime,
  entityKey: 'market',
  pagination: _useGetMarketBoosterLeaderboardPaginationContract,
});
export const useGetMarketBoosterLeaderboard = _useGetMarketBoosterLeaderboard as (args: useGetMarketBoosterLeaderboardArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetMarketBoosterLeaderboard>;


/**
 * Auto-infinite: same cache as `useGetMarketBoosterLeaderboard`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetMarketBoosterLeaderboard` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetMarketBoosterLeaderboardInfinite = createListHook({
  spec: useGetMarketBoosterLeaderboardSpec,
  realtime: useGetMarketBoosterLeaderboardRealtime,
  entityKey: 'market',
  pagination: _useGetMarketBoosterLeaderboardPaginationContract,
  autoLoadMore: true,
});
export const useGetMarketBoosterLeaderboardInfinite = _useGetMarketBoosterLeaderboardInfinite as (args: useGetMarketBoosterLeaderboardArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetMarketBoosterLeaderboardInfinite>;


/**
 * Per-field subscription hook for the `useGetMarketBoosterLeaderboard` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetMarketBoosterLeaderboardField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetMarketBoosterLeaderboardField = createFieldHook<GetMarketBoosterLeaderboardRow>('useGetMarketBoosterLeaderboardField');

/**
 * Hover/intent prefetch companion for `useGetMarketBoosterLeaderboard` (also covers
 * `useGetMarketBoosterLeaderboardInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetMarketBoosterLeaderboard();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetMarketBoosterLeaderboard = createPrefetchHook(useGetMarketBoosterLeaderboardSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetMarketBoosterLeaderboardArgs>;
